// extracted by mini-css-extract-plugin
export default {"panel":"closable-panel_panel__cqLbZ","closer":"closable-panel_closer__jZUr1"};